<template>
  <div
    class="section-row"
    id="clarinit"
  >
    <div class="">
      <h1 class="section-title text-center mb-10">Archivio Vi.Vo. @ CLARIN-IT</h1>
      <hr class="customhr">
      <div style="margin-top: 40px">
        <a
          href="https://www.clarin-it.it/it"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="../assets/images/clarinitlogo.png"
            class="section-img-right rounded"
          >
        </a>
        <p>
          <a
            href="https://www.clarin.eu/"
            target="_blank"
            rel="noopener noreferrer"
          >CLARIN</a>
          (Common Language Resources and Technology Infrastructure Consortium) è un’infrastruttura di ricerca di tipo ERIC che mira ad integrare a livello europeo risorse linguistiche e strumenti avanzati di ricerca, di accesso e di analisi dei contenuti digitali al servizio degli studiosi nel campo delle Scienze Umane e Sociali (SSH). Tale obiettivo è perseguito attraverso la creazione di una rete di centri nazionali distribuiti sul territorio europeo che forniscono depositi di dati linguistici digitali (repository), strumenti altamente avanzati e archivi fisici e digitali all’avanguardia che, tramite un servizio di accesso unificato, sono messi a disposizione della comunità scientifica del settore per condurre ricerche di alto livello a sostegno dell’innovazione e della competitività.
        </p>
        <p>
          In Italia, l’infrastruttura di ricerca CLARIN-ERIC fa capo al
          <a
            href="https://www.cnr.it/it/dipartimento/514/scienze-umane-e-sociali-patrimonio-culturale"
            target="_blank"
            rel="noopener noreferrer"
          >CNR – Dipartimento Scienze Umane e Sociali Patrimonio Culturale</a>
          . Il consorzio italiano
          <a
            href="https://www.clarin-it.it/it"
            target="_blank"
            rel="noopener noreferrer"
          >CLARIN-IT</a>
          è coordinato per il CNR dalla Dott.ssa Monica Monachini dell’
          <a
            href="http://www.ilc.cnr.it/it/content/istituto"
            target="_blank"
            rel="noopener noreferrer"
          >Istituto di Linguistica Computazionale "Antonio Zampolli" di Pisa</a>
          . Le attività tecnologiche di implementazione del nodo nazionale sono gestite presso l’Istituto di Linguistica Computazionale "Antonio Zampolli" (CNR-ILC) di Pisa.
        </p>
        <p>
          Il data center nazionale
          <a
            href="https://ilc4clarin.ilc.cnr.it/en/"
            target="_blank"
            rel="noopener noreferrer"
          >ILC4CLARIN</a>
          fornisce all’intera comunità scientifica italiana un sistema di accesso e autenticazione federata, così da consentire consultazione e accesso sicuro al patrimonio dei dati linguistici digitali prodotti in Italia, nonché la loro reperibilità e preservazione e visibilità; offre inoltre un set di strumenti linguistici digitali sotto forma di servizi di facile utilizzo e garantisce la consultazione e l’utilizzo dei dati e degli strumenti messi a disposizione da tutti gli altri consorzi nazionali aderenti all’infrastruttura europea CLARIN.
        </p>
        <p>Archivio Vi.Vo. mira a costituire uno studio pilota nell'ambito di CLARIN-IT per sperimentare metodi e offrire servizi alle discipline interessate alle fonti orali. All'interno di Archivio Vi.Vo. il repository ILC4CLARIN sarà migliorato attraverso un approccio sperimentale alla conservazione, alla gestione e all'accesso a dati e metadati audio.</p>
        <a
          href="https://www.garr.it/it/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="../assets/images/garrlogo.png"
            class="section-img-left rounded"
          >
        </a>
        <p>
          L'attività sperimentale mirerà ad adottare il modello e i servizi di elaborazione e archiviazione ad alte prestazioni dell’infrastruttura di
          <a
            href="https://www.garr.it/it/"
            target="_blank"
            rel="noopener noreferrer"
          >rete GARR</a>
          , rete nazionale a banda ultralarga dedicata alla comunità dell’istruzione e della ricerca
        </p>
        <p>Archivio Vi.Vo. & CLARIN-IT svilupperanno un modello che può essere replicato su altri archivi audiovisivi, anche al di fuori del contesto della Toscana. Questo modello sarà diffuso sia alle diverse comunità scientifiche che a vario titolo usano fonti orali, sia al grande pubblico appassionato di racconti e tradizioni orali prodotti nel territorio.</p>
      </div>
    </div>
  </div>
</template>